export default function initSimpleMenu() {
  Alpine.data('simpleMenu', () => ({
    openDropdown: new Map<string, boolean>(),
    openLanguage: false,
    toggleMenuSectionOpen(key: string) {
      this.openDropdown.set(key, this.openDropdown.has(key) ? !this.openDropdown.get(key) : true);
    },
    closeMenuSectionOpen(key: string) {
      this.openDropdown.set(key, false);
    },
    menuSectionOpen(key: string) {
      return this.openDropdown.has(key) && this.openDropdown.get(key);
    },
    toggleLanguageOpen() {
      this.openLanguage = !this.openLanguage;
    },
  }));
}
